export default __webpack_public_path__ + "static/media/wcas_logo_trim_small.ebd6b476.png";